import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ROLES } from '../constants';
import { isTokenExpired } from '../helpers/authService';
import { handleSessionEnd } from '../helpers/common';

/**
 * Protects routes by requiring a logged-in user and optional role.
 * Role checks here are for UX only; the backend must enforce authorization on every API call.
 */
const PrivateRoute = ({ component: Component, roles, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            let user = null;
            try {
                const stored = localStorage.getItem('user');
                user = stored ? JSON.parse(stored) : null;
            } catch {
                user = null;
            }

            // If user is not logged in, redirect to login
            if (!user) {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
            }

            // If token is expired, session end (toast + logout + redirect) and avoid rendering protected content
            if (isTokenExpired()) {
                handleSessionEnd('expired');
                return null;
            }

            // If route requires a role and the user's role doesn't match, redirect to home
            if (roles && roles.length > 0 && roles.indexOf(user.data.UserRole) === -1) {
                return <Redirect to={{ pathname: '/' }} />;
            }

            // Otherwise, render the component
            return <Component {...props} />;
        }}
    />
);

export default PrivateRoute;